import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthService } from '../../../services/auth.service';
import { loginRequest } from '../../../../auth-config';
import { ModalService } from 'src/app/shared/services/modal.service';
import { MyProfilePopupComponent } from '../../my-profile-popup/my-profile-popup.component';
import { filter } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  public userDetailsData: any;
  private readonly authService: AuthService = inject(AuthService);

  constructor(
    private readonly modalService: ModalService,
    private readonly destroyRef: DestroyRef,
  ) {}

  ngOnInit() {
    this.loadUserDetails(); // Run initially

    this.authService.isUserDetailsChanged
      .pipe(
        filter(val => val === true),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => {
        this.loadUserDetails();
        this.authService.userDetailsChanged(false);
      });
  }

  public login() {
    this.authService.login(loginRequest);
  }

  public logout() {
    this.authService.initiateLogout();
  }

  public redirectToUserProfile() {
    this.modalService.openPopup(
      {},
      'My Profile',
      MyProfilePopupComponent,
      '70vw'
    );
  }

  private loadUserDetails() {
    try {
      const userDetailsString = localStorage.getItem('userDetails');
      if (userDetailsString) {
        this.userDetailsData = JSON.parse(userDetailsString);
      }
    } catch (error) {
      this.userDetailsData = null;
    }
  }
}
